export const generateEnhancedMaxLimitReachedMessage = (things: string, maximum: number) => {
  return `No more ${things} can be added under your current plan (max ${maximum}). To learn more about other plans, you can send a message to a Persona representative.`;
};
